"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = exports.InputWrapper = exports.InputWithIcons = exports.InputWithErrorMessage = exports.IconWrapper = exports.HelperText = exports.ErrorMessage = exports.Input = exports.Label = exports.InputWithLabelWrapper = void 0;
const styled_components_1 = __importStar(require("styled-components"));
exports.InputWithLabelWrapper = styled_components_1.default.div `
  position: relative;
  display: flex;
`;
exports.Label = styled_components_1.default.label `
  position: absolute;
  pointer-events: none;
  z-index: 2;
  top: 14px;
  left: 20px;
  background-color: ${({ theme }) => theme.white};
  padding: 2px 4px;
  color: ${({ isError, isSuccess, isDisabled, theme }) => {
    if (isDisabled) {
        return theme.neutral.main;
    }
    else if (isError) {
        return theme.error.main;
    }
    else if (isSuccess) {
        return theme.success.main;
    }
    else {
        return theme.neutral.main;
    }
}};
  font-size: 16px;
  font-weight: 700;

  transition: top 0.1s ease-in-out, left 0.1s ease-in-out;

  color: ${({ isError, isSuccess, isDisabled, isFocused, theme }) => {
    const color = isDisabled
        ? theme.neutral.main
        : isError
            ? theme.error.main
            : isSuccess
                ? theme.success.main
                : isFocused
                    ? theme.primary.main
                    : theme.neutral.main;
    return color;
}};

  ${({ isFocused, hasValue }) => (isFocused || hasValue) &&
    (0, styled_components_1.css) `
      top: -10px;
      left: 12px;
      font-size: 14px;
      font-weight: 400;
    `};
`;
exports.Input = styled_components_1.default.input `
  color: ${({ theme }) => theme.neutral.dark};
  font-size: 16px;
  line-height: 18px;
  border: none;
  border-radius: 8px;
  padding: 12px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.white};

  text-align: ${({ isRightAligned }) => (isRightAligned ? "right" : "left")};

  &:focus {
    outline: none;
  }

  &::placeholder {
    transition: opacity 0.1s ease-in-out;
    opacity: 0;
  }

  &:focus::placeholder {
    opacity: 1;
  }
`;
exports.ErrorMessage = styled_components_1.default.p `
  margin: 10px 0 0 20px;
  position: absolute;
  font-weight: normal;
  font-size: 14px;
  line-height: 14px;
  letter-spacing: 0.4px;
  color: ${({ theme }) => theme.error.main};
`;
exports.HelperText = styled_components_1.default.p `
  margin: 10px 0 0 20px;
  position: absolute;
  font-weight: normal;
  font-size: 14px;
  line-height: 14px;
  letter-spacing: 0.4px;
  color: ${({ theme }) => theme.text.primary};
`;
exports.IconWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;

  ${({ isFocused, hasValue }) => (isFocused || hasValue) &&
    (0, styled_components_1.css) `
      opacity: 1;
    `};
`;
exports.InputWithErrorMessage = styled_components_1.default.div `
  position: relative;
  width: ${({ width }) => (width ? `${width}px` : "100%")};
`;
exports.InputWithIcons = styled_components_1.default.div `
  display: flex;
  width: 100%;
  border: ${({ isError, isSuccess, isDisabled, theme }) => {
    const color = isDisabled
        ? theme.neutral.main
        : isError
            ? theme.error.main
            : isSuccess
                ? theme.success.main
                : theme.neutral.main;
    return `2px solid ${color}`;
}};

  box-sizing: border-box;
  height: 52px;
  width: 100%;
  border-radius: 8px;
  ${({ isFocused }) => isFocused &&
    (0, styled_components_1.css) `
      outline: none;
      border-color: ${({ isError, isSuccess, theme }) => {
        if (isError) {
            return theme.error.main;
        }
        else if (isSuccess) {
            return theme.success.main;
        }
        else {
            return theme.primary.main;
        }
    }};
    `};
`;
exports.InputWrapper = styled_components_1.default.div `
  overflow: hidden;
  flex-grow: 1;
  border-radius: 8px;
`;
exports.Wrapper = styled_components_1.default.div `
  margin: 12px 12px 40px;
  position: relative;
  opacity: ${({ isDisabled }) => (isDisabled ? 0.5 : 1)};

  &:hover {
    ${exports.Label} {
      color: ${({ isError, isSuccess, isDisabled, isFocused, theme }) => {
    const color = isDisabled
        ? theme.neutral.main
        : isError
            ? theme.error.main
            : isSuccess
                ? theme.success.main
                : isFocused
                    ? theme.primary.main
                    : theme.neutral.dark;
    return color;
}};
    }

    ${exports.InputWithIcons} {
      border-color: ${({ isError, isSuccess, isDisabled, isFocused, theme }) => {
    const color = isDisabled
        ? theme.neutral.main
        : isError
            ? theme.error.main
            : isSuccess
                ? theme.success.main
                : isFocused
                    ? theme.primary.main
                    : theme.neutral.dark;
    return color;
}};
    }
  }
`;
